<template>
  <div class="modal-backdrop dormant-phone-backdrop" @keydown.esc="$emit('close')">
    <section class="dormant-phone-dialog" role="dialog" aria-modal="true" aria-labelledby="dormant-phone-title">
      <h2 id="dormant-phone-title">绑定手机</h2>
      <p>您的账号尚未绑定手机，绑定后可及时接收账户安全通知。</p>
      <div class="dormant-phone-actions">
        <button ref="cancelButton" type="button" @click="$emit('close')">稍后再说</button>
        <button type="button" class="primary" @click="$emit('bind')">去绑定</button>
      </div>
    </section>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'

defineEmits(['close', 'bind'])
const cancelButton = ref(null)
let previousFocus
onMounted(() => {
  previousFocus = document.activeElement
  cancelButton.value?.focus()
})
onBeforeUnmount(() => previousFocus?.focus?.())
</script>

<style scoped>
.dormant-phone-backdrop { z-index: 11000; }
.dormant-phone-dialog { width: min(420px, calc(100vw - 32px)); padding: 28px; border-radius: 12px; background: #fff; color: #26364a; box-shadow: 0 20px 60px #0003; }
.dormant-phone-dialog h2 { margin: 0 0 16px; font-size: 20px; }
.dormant-phone-dialog p { margin: 0; line-height: 1.8; }
.dormant-phone-actions { display: flex; justify-content: flex-end; gap: 12px; margin-top: 24px; }
.dormant-phone-actions button { min-width: 92px; min-height: 40px; padding: 8px 16px; border: 1px solid #dce2ec; border-radius: 7px; background: #f5f7fa; color: #26364a; cursor: pointer; }
.dormant-phone-actions .primary { border-color: #2476f3; background: #2476f3; color: #fff; }
</style>
